import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ae33814")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    id: _ctx.idName,
    onClick: _cache[1] || (_cache[1] = () => (!_ctx.disabled ? _ctx.generateCsv() : null))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 8, ["id"]))
})